import React from 'react';
import { motion } from 'framer-motion';

const Intro = ({ onFinish }) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-bodyColor"
      onAnimationComplete={() => {
        // Fallback safety: ensure onFinish is called if main sequence finishes
        setTimeout(onFinish, 6000); 
      }}
    >
      {/* Background decoration */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute w-[500px] h-[500px] rounded-full bg-designColor blur-[100px]"
      />

      <div className="relative z-10 flex flex-col items-center">
        {/* Name Animation */}
        <motion.h1
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
          className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-wider font-primary"
        >
          <span className="text-designColor">Osama</span> Ali
        </motion.h1>

        {/* Title Animation */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 0.8, delay: 1.3, ease: "easeInOut" }}
          className="h-[2px] bg-designColor mb-4 overflow-hidden"
        />

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 2.1 }}
          className="text-lg md:text-2xl text-gray-300 font-light tracking-widest uppercase"
        >
          Software Engineer
        </motion.p>

        {/* Loading Bar */}
        <div className="mt-12 w-64 h-1 bg-gray-800 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 3, delay: 2.5, ease: "easeInOut" }}
            className="h-full bg-designColor shadow-[0_0_10px_#6366f1]"
            onAnimationComplete={onFinish}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Intro;
